import type { CSSProperties } from 'react'

// Staggers a data-reveal element: it waits this long after scrolling into view.
export const revealDelay = (ms: number): CSSProperties => ({ '--reveal-delay': `${ms}ms` } as CSSProperties)

// Staggers a load-in animation (ld-rise, ld-fade, ld-unveil, ld-menu-item).
export const animationDelay = (ms: number): CSSProperties => ({ '--delay': `${ms}ms` } as CSSProperties)
